module.exports = __webpack_public_path__ + "static/media/avatar_agent.0d201d9f.svg";